import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

const Homepage = () => {
  return (
    <div className="hero-section d-flex align-items-center">
      <Container className="mt-5 pt-5">
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <div className="hero-content fade-in">
              <div className="logo-container">
                <div className="logo">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-4 mb-3">
                  <div className="logo" style={{ width: '100px', height: '100px', fontSize: '1.5rem' }}>
                    <i className="fas fa-baby"></i>
                  </div>
                  <div className="text-white fs-2 fw-bold">×</div>
                  <div className="logo" style={{ width: '100px', height: '100px', fontSize: '1.5rem' }}>
                    <i className="fas fa-home"></i>
                  </div>
                </div>
              </div>
              
              <h1 className="company-name slide-in-left">
                Lil Humans & Havens
              </h1>
              
              <p className="tagline slide-in-right">
                Leave Management System
              </p>
              
              <div className="mb-4">
                <p className="text-white fs-5 opacity-75">
                  Streamline your leave requests and approvals with our comprehensive management system
                </p>
              </div>
              
              <div className="d-flex flex-column flex-md-row gap-3 justify-content-center align-items-center">
                <Link to="/login" className="cta-button">
                  <i className="fas fa-sign-in-alt me-2"></i>
                  Login to Your Account
                </Link>
              </div>
              
              <div className="mt-5">
                <Row className="text-center">
                  <Col md={4} className="mb-3">
                    <div className="text-white">
                      <i className="fas fa-users fs-1 mb-3 opacity-75"></i>
                      <h5>Employee Management</h5>
                      <p className="opacity-75">Manage employee profiles and access controls</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3">
                    <div className="text-white">
                      <i className="fas fa-calendar-check fs-1 mb-3 opacity-75"></i>
                      <h5>Leave Requests</h5>
                      <p className="opacity-75">Submit and track leave requests easily</p>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3">
                    <div className="text-white">
                      <i className="fas fa-chart-line fs-1 mb-3 opacity-75"></i>
                      <h5>Analytics & Reports</h5>
                      <p className="opacity-75">Get insights into leave patterns and trends</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '10%',
        width: '100px',
        height: '100px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '50%',
        animation: 'float 6s ease-in-out infinite'
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '20%',
        right: '15%',
        width: '150px',
        height: '150px',
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '50%',
        animation: 'float 8s ease-in-out infinite reverse'
      }}></div>
      
      <div style={{
        position: 'absolute',
        top: '60%',
        left: '5%',
        width: '80px',
        height: '80px',
        background: 'rgba(255, 255, 255, 0.08)',
        borderRadius: '50%',
        animation: 'float 7s ease-in-out infinite'
      }}></div>
      
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </div>
  );
};

export default Homepage;